import React from 'react';
import s from './ApproveAskPopup.module.css';
import {useTranslation} from 'react-i18next';
import ModalWrapper from '../ModalWrapper/ModalWrapper';

type Props = {
	approvedCallback: () => void;
	canceledCallback: () => void;
	questionText?: string;
};
const ApproveAskPopup: React.FC<Props> = ({
	approvedCallback,
	canceledCallback,
	questionText,
}) => {
	const {t} = useTranslation();

	return (
		<ModalWrapper handleClosePopup={canceledCallback}>
			<div className={s.container}>
				<div className={s.popupTitle}>
					{questionText ? questionText : t('Підтвердження дії')}
				</div>
				<div className={s.popupButtons}>
					<button
						type={'button'}
						className={s.greenButton}
						onClick={approvedCallback}
					>
						{t('Так')}
					</button>
					<span>{t('або')}</span>
					<button
						onClick={canceledCallback}
						type={'button'}
						className={s.redButton}
					>
						{t('Ні')}
					</button>
				</div>
			</div>
		</ModalWrapper>
	);
};

export default ApproveAskPopup;
